<template>
    <div class="login-wrapper">
        <div class="login-box">
            <img src="../../assets/img/login_logo.png" alt="" class="login-logo">
            <div class="login-form">
                <h3>登录</h3>
                <div class="form-item">
                    <div class="form-icon">
                        <img src="../../assets/img/account.png" alt="">
                    </div>
                    <input type="text" placeholder="请输入用户名" v-model="account">
                </div>
                <div class="form-item">
                    <div class="form-icon">
                        <img src="../../assets/img/pass.png" alt="">
                    </div>
                    <input type="password" placeholder="请输入密码" v-model="pass">
                </div>
                <div class="form-item">
                    <drag-verify
                        ref="dragVerify"
                        :width="405"
                        :height="48"
                        :circle="false"
                        :textSize="'14px'"
                        completedBg="#368ad1"
                        progressBarBg="#368ad1"

                        :isPassing.sync="isPassing"
                        text="请按住滑块拖动"
                        successText="验证通过"
                        handlerIcon="el-icon-d-arrow-right"
                        successIcon="el-icon-circle-check"
                        @passcallback="passcallback">
                    </drag-verify>
                </div>
                <div class="login-btn" @click="loginSubmit">立即登录</div>
            </div>
        </div>
        <div class="footer-warrper">
            Copyright 益魔方 <a class="margin-left-xs" target="_blank" href="http://beian.miit.gov.cn">京ICP备15038897号-3</a><img class="beian" src="../../assets/img/beian.png">
            <a class="margin-right-xs" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214">京公网安备11010802038214号</a>北京易魔方科技集团有限公司 版权所有
        </div>
    </div>
</template>

<script>
import dragVerify from 'vue-drag-verify2'
import {login} from "@/api/login";

export default {
    name: "login",
    data() {
        return {
            account: '',
            pass: '',
            isPassing: false
        }
    },
    created() {
    },
    components: {
        dragVerify
    },
    methods: {
        passcallback() {
            this.isPassing = true
        },
        async loginSubmit() {
            if (!this.account) return this.$message.error('请输入用户名')
            if (!this.pass) return this.$message.error('请输入密码')
            if (!this.isPassing) return this.$message.error('请滑动验证')
            const loading = this.$loading({
                lock: true,
                text: '登录中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _data = await login(this.account, this.pass)
            loading.close();
            if (_data.status === 200) {
                this.$store.state.token = _data.data.token
                // this.$store.state.user = _data.data
                this.$router.replace('/admin')
            } else {
                this.isPassing = false
                this.$refs.dragVerify.reset();
            }


        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.login-wrapper {
    width: 100%;
    height: 100vh;
    background: url(../../assets/img/login_bg.png) #f5f5f5 no-repeat top center;
    background-size: 100% 100%;

    .login-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .login-logo {
            display: block;
            margin: 30px auto;
        }

        .login-form {
            width: 958px;
            height: 549px;
            padding: 80px 100px 0 430px;
            background: url(../../assets/img/login_form.png) no-repeat center;

            h3 {
                font-size: 24px;
                line-height: 38px;
                letter-spacing: 2px;
                color: #368ad1;
                text-align: center;
                margin-bottom: 30px;
            }

            .form-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 405px;
                height: 50px;
                margin: 0 auto 20px;
                border-radius: 4px;
                border: solid 1px #e6e6e6;
                overflow: hidden;

                .form-icon {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    width: 46px;
                    height: 46px;

                    img {
                        width: 16px;
                    }
                }

                input {
                    flex: 1;
                    display: block;
                    font-size: 16px;
                    height: 46px;
                    background: transparent;
                }

                .form-btn {
                    padding: 0 10px;
                    color: #009688;
                }

                .form-yzm {
                    display: block;
                    width: 120px;
                    height: 46px;
                }
            }

            .login-btn {
                display: block;
                width: 425px;
                height: 56px;
                margin: 0 auto;
                text-align: center;
                line-height: 54px;
                font-size: 18px;
                color: #fff;
                background-color: #368ad1;
                border-radius: 6px;
                border: solid 1px #eeeeee;
                cursor: pointer;
            }
        }
    }

    .footer-warrper {
        width: 100%;
        position: fixed;
        bottom: 12px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #ffffff;
        font-size: 12px;

        &.black {
            background-color: #2f2f2f;
            color: #f5f5f5;
        }

        .beian {
            width: 12px;
            height: 12px;
            margin: 0 5px;
        }

        a {
            font-size: 12px;
            line-height: 12px;
            color: #ffffff;

            &.black {
                color: #f5f5f5;
            }
        }
    }

}
</style>
